import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import { ButtonSize } from '@wix/da-ds/pkg/Buttons/types';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

export interface Props {
  className?: string;
  iconSizeOverride?: ButtonSize;
}

const GalleryDisplaySettingsDropdown: React.FC<Props> = ({
  className,
  iconSizeOverride,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleOpenModal = useCallback(() => {
    dispatch(
      pushModal(ModalType.GALLERY_DISPLAY_SETTINGS, {
        biContext: { sectionname: 'studio' },
      })
    );
  }, [dispatch]);

  const menuItems = [
    {
      label: t('galleryDisplaySettings.menuItem'),
      onClick: handleOpenModal,
    },
  ];

  return (
    <IconButtonWithContextMenu
      icon={EllipsisIcon}
      withBackground
      items={menuItems}
      className={className}
      size={iconSizeOverride || 'small'}
      aria-label={t('common.moreActions')}
    />
  );
};

GalleryDisplaySettingsDropdown.displayName = 'GalleryDisplaySettingsDropdown';

export default GalleryDisplaySettingsDropdown;
